<div class="datepicker-inline-container">
  <!-- Datepicker inline com cabeçalho customizado -->
  <mat-calendar
    #calendar
    [dateClass]="dateClass"
    [(selected)]="selected"
    [headerComponent]="cabecalhoComponent"
    [class.ocultar-conteudo]="!$mostrarConteudo()"
    (selectedChange)="onSelected($event!)"
  >
  </mat-calendar>
</div>
